import config from "../config";
import BaseApi from "./baseApi";

// Cliente chico y sin Bearer token: es pre-autenticación, todavía no hay
// accessToken. login-gateway espera el deviceToken en el header
// `X-Device-Token`, no en el body (ver login-gateway/src/handler.ts).
const client = new BaseApi(config.loginGatewayUrl);

// Statuses de /auth/login que significan "todavía no se completó el login, falta el
// código OTP" -- login-gateway/src/controllers/auth/postLogin.ts es la fuente de verdad.
export const OTP_PENDING_STATUSES = ["challenge_required", "challenge_already_active"];

// Idem, pero para el reset de contraseña forzado -- independiente del OTP de arriba (ver
// login-gateway/src/lib/passwordReset.ts). No hay challengeId ni segundo paso acá: el
// usuario tiene que ir a "Olvidé mi contraseña" y volver a loguearse cuando la cambie.
export const PASSWORD_RESET_REQUIRED_STATUS = "password_reset_required";

export const login = (email, password, deviceToken) =>
  client.post(
    "/auth/login",
    { email, password },
    deviceToken ? { headers: { "X-Device-Token": deviceToken } } : undefined
  );

export const verify = (challengeId, code) =>
  client.post("/auth/verify", { challengeId, code });

// La recuperación de contraseña pasa por acá (y no directo a `api`) para que
// login-gateway sepa con certeza en qué momento un usuario con reset forzado cambió su
// contraseña de verdad -- ver login-gateway/src/controllers/auth/postPasswordRecoveryChange.ts.
export const requestPasswordRecovery = (email) =>
  client.post("/auth/passwordRecovery/request", { email });

export const changePassword = (body) =>
  client.post("/auth/passwordRecovery/change", body);
